import { RouteConfig } from 'vue-router';
import { AdminRoles } from '@/configs/role';

const residentRoutes: RouteConfig = {
  path: 'resident',
  component: () => import(/* webpackChunkName: 'dashboard.resident' */ '@/pages/resident/Index.vue'),
  redirect: {
    name: 'home',
  },
  children: [
    {
      path: 'project/:projectId/list',
      name: 'resident-list',
      component: () => import(/* webpackChunkName: 'dashboard.resident' */ '@/pages/resident/List.vue'),
      meta: {
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor, AdminRoles.staff],
      },
    },
    {
      path: 'project/:projectId/create',
      name: 'resident-create',
      component: () => import(/* webpackChunkName: 'dashboard.resident' */ '@/pages/resident/Edit.vue'),
      meta: {
        action: 'create',
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor, AdminRoles.staff],
      },
    },
    {
      path: 'project/:projectId/user/:userId/edit',
      name: 'resident-edit',
      component: () => import(/* webpackChunkName: 'dashboard.resident' */ '@/pages/resident/Edit.vue'),
      meta: {
        action: 'edit',
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor, AdminRoles.staff],
      },
    },
  ],
};

export default residentRoutes;
